




































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from '../../models/exam'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { ROUTER_NAME } from '../../router'
import { format } from 'date-fns'

@Component({
  components: {
  }
})
export default class ExamRecommendationList extends Vue {
  isMobile: boolean = false
  LETTER_FORMAT = LETTER_FORMAT
  drawer: boolean = false

  get exams() {
    return examState.listRecommendationExam.list
  }

  get isLoading() {
    return examState.listRecommendationExam.isLoading
  }

  get pagination() {
    return examState.listRecommendationExam.pagination
  }

  get currentExams(): Exam[] {
    return this.exams
  }

  get title(): string {
    return 'すべてのテスト'
  }

  async created() {
    await examState.getRecommendationList()
    headerState.setTitle('テスト一覧')
    footerState.setFooterDefault()
  }

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  selectPage(page) {
    examState.getList(page)
  }

  onResize() {
    this.isMobile = window.innerWidth < 600
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm')
  }
}
